'use strict';

var _ = require('lodash');
var d3 = require('d3');
var ChartDashboardPerformance = function ChartDashboardPerformance(AbstractChart, scalesService, chartGroups, chartStripes, chartXAxis, chartYAxis, chartCircles, chartTiles, chartBrush, chartConstants) {
  var chartParams = require('./Params');
  var Chart = function Chart(container, formatters) {
    AbstractChart.call(this, container);
    // chart components
    var groups = chartGroups('month', formatters && formatters.tooltipFormatter, true);
    groups.on('groupclick', function (d, i) {
      brush.setSelection([i, i + 1]);
    });
    var stripes = chartStripes('data');
    var xAxisTickValuesHandler = function xAxisTickValuesHandler(data) {
      return _.map(data, 'month');
    };
    var tiles = chartTiles('any', 'value', 'tiles').withHeight(2);
    var xAxis = chartXAxis(formatters.xAxisTickFormatter, xAxisTickValuesHandler).withoutLine();
    var yAxisLeft = chartYAxis(formatters.yAxisTickFormatter, chartConstants.AXIS.MODE.LEFT);
    var dispatch = d3.dispatch('rangechange');
    d3.rebind(this, dispatch, 'on');
    var brush = chartBrush();
    brush.on('brushchange', function (range) {
      dispatch.rangechange(range);
      this.brushChangeAction(range, groups);
    }.bind(this));
    yAxisLeft.label('Booking');
    var circles = chartCircles('circles');
    function updateBrushSelection(domainLength) {
      var selection = brush.getSelection();
      var selectionSize = selection[0][1] - selection[0][0];
      if (selectionSize === 0) {
        brush.setSelection([0, domainLength]);
      } else {
        _.forEach(selection, function (s) {
          brush.updateBrush(s);
        });
      }
    }
    function clearTopBarLevelTiles(data, yScale) {
      for (var i = 0; i < data.length; i++) {
        var element = data[i];
        element.stackLabel = formatters.xAxisTickFormatter(element.month, i).replace(' \'', '');
        if (element.tiles.length) {
          var renderedTilesValue = yScale(element.tiles[0].value);
          var renderedBarValue = yScale(element.data[0]);
          if (renderedBarValue === renderedTilesValue) {
            element.tiles.length = 0;
          }
        }
      }
    }
    this.render = function (data) {
      this.initChart(data, undefined, chartParams);
      this.scales = scalesService.createPositiveNegativeBarScale(this.params, this.data, 'month');
      clearTopBarLevelTiles(data, this.scales.yScale);
      this.callForDataGroup([yAxisLeft, groups, stripes, tiles, circles, xAxis], this.scales);
      this.callForPreDataGroup([brush.withDomainRange(this.visibleXRange)], this.scales);
      updateBrushSelection(this.scales.xScale.domain().length);
    };
    this.clearBrush = function () {
      brush.clear();
    };
    this.resetBrushSelection = function () {
      brush.setSelection([0, this.scales.xScale.domain().length]);
    };
    this.changeMetrics = function (value, selectedMetric) {
      yAxisLeft.label(selectedMetric);
    };
    this.getBrushSelection = function () {
      var selectedBarsNumbers = brush.getSelection(),
        selectedBars = [];
      for (var i in selectedBarsNumbers) {
        selectedBars[i] = [];
        if (selectedBarsNumbers[i]) {
          for (var j = selectedBarsNumbers[i][0], last = selectedBarsNumbers[i][1]; j < last; j++) {
            var bar = this.data[j].metrics;
            bar.position = this.data[j].position;
            selectedBars[i].push(bar);
          }
        }
      }
      return selectedBars;
    };
    container.on('$destroy', function () {
      groups.on('groupclick', null);
      brush.on('brushchange', null);
      brush.on('brushend', null);
    });
  };
  Chart.prototype = Object.create(AbstractChart.prototype);
  Chart.constructor = Chart;
  return Chart;
};
ChartDashboardPerformance.$inject = ['AbstractChart', 'ScalesService', 'ChartElementsGroup', 'ChartElementsStripes', 'ChartElementsXAxis', 'ChartElementsYAxis', 'ChartElementsCircles', 'ChartElementsTiles', 'ChartElementsMultiBrush', 'ChartElementsConstants'];
module.exports = ChartDashboardPerformance;